import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'PERSONSPONSOR',
  inside: {
    player: { get: 'personSponsors', set: 'personSponsor' },
  },
});
